//@ts-nocheck
import * as React from 'react';
import MapContainer from "../../Common/MapContainer";

class CongressionalDistrictMaps extends React.Component<Props, {}> {

    render() {
        const { university, start_year, current_year, congress_map, congress_map_range, usStateList, state_fips } = this.props;

        if (congress_map && congress_map_range && usStateList && state_fips)
            
            return (
                <div className="row">
                    <div className="col-md-6">
                        <div className="congressmap_div">
                            <h4>{university}<br />Federal Research-Related Spending {current_year}</h4>
                            <MapContainer
                                    factSheet={true}
                                    isInState={true}
                                    isZoomed={false}
                                    isCongress={true}
                                    state_fips={state_fips}
                                    mapData={congress_map}
                                    USState={usStateList}
                                />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="congressmap_div">
                            <h4>{university}<br />Federal Research-Related Spending {start_year}-{current_year}</h4>
                            <MapContainer
                                    factSheet={true}
                                    isInState={true}
                                    isZoomed={false}
                                    isCongress={true}
                                    state_fips={state_fips}
                                    mapData={congress_map_range}
                                    USState={usStateList}
                                />
                        </div>
                    </div>
                </div>
            );
        else return (<div></div>)
    }
}

export default CongressionalDistrictMaps;